export const isInFuture = (timestamp: string) => {
  return new Date(timestamp).getTime() - Date.now() > 0;
};
